import { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BibleProvider } from './context/BibleContext';
import { UserProvider } from './context/UserContext';
import { ThemeProvider } from './context/ThemeContext';
import { AnnotationsProvider } from './context/AnnotationsContext';
import Header from './components/Header';
import BookView from './components/BookView';
import UserLogin from './components/UserLogin';
import UserSignup from './components/UserSignup';
import VersionInfo from './components/VersionInfo';

function BibleApp() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = useCallback((query: string) => {
    setSearchQuery(query);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchQuery('');
  }, []);

  return (
    <BibleProvider>
      {/* Full-viewport shell: header and footer stay put, only the panels' verse lists scroll. */}
      <div className="h-screen flex flex-col overflow-hidden bg-gray-100 dark:bg-ink-900">
        <Header onSearch={handleSearch} onClearSearch={handleClearSearch} />

        <div className="flex-1 min-h-0 w-full px-4 pt-4 pb-2">
          <BookView
            searchQuery={searchQuery}
            onClearSearch={handleClearSearch}
          />
        </div>

        <footer className="flex-shrink-0 py-2">
          <div className="px-4 text-center">
            <VersionInfo />
          </div>
        </footer>
      </div>
    </BibleProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <UserProvider>
          {/* Above the routes, so an anonymous reader's highlights and bookmarks survive the trip to /login. */}
          <AnnotationsProvider>
            <Routes>
              <Route path="/" element={<BibleApp />} />
              <Route path="/login" element={<UserLogin />} />
              <Route path="/signup" element={<UserSignup />} />
            </Routes>
          </AnnotationsProvider>
        </UserProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
